import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import moment from "moment";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Head from "next/head";
import striptags from "striptags";
import Link from "next/link";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";
import Image from "next/image";
import CommonCtaSection from "../../components/common/CTASection/CommonCtaSection";
import FaqSection from "../../components/Blog/FaqSection";

const Loader = dynamic(() => import("../../components/common/Loader/Loader"));
const Layout = dynamic(() => import("../../components/common/Layout/Layout"));

const BlogDetail = ({ apiData }) => {
	const router = useRouter();
	const [activeTab, setActiveTab] = useState();
	const [showAllFaqs, setShowAllFaqs] = useState(true);
	const [data, setData] = useState();
	const [loader, setLoader] = useState(true);
	const [authorLogo, setAuthorLogo] = useState();
	const [socialIcon, setSocialIcon] = useState();
	const commonCtaData = apiData?.body?.find((block) => block?.type === "cta");
	const formattedDate = moment(data && data?.date_published).format(
		"MMMM Do, YYYY"
	);

	const title = apiData?.page_title;
	const seo_title = apiData?.meta?.seo_title;
	const search_description = apiData?.meta?.search_description;
	const canonicalUrl = apiData?.canonical_url;
	const og_title = apiData?.og_title;
	const og_description = apiData?.og_description;
	const og_image = apiData?.og_image?.url;
	const structuredData = apiData?.struct_org_extra_json;
	const formatJson = (json) => {
		return {
			__html: `${json}`,
		};
	}
	const [activeItem, setActiveItem] = useState(0);

	const footerData = useSelector(
		(state) => state.headerFooterData.headerFooterDataList
	);

	useEffect(() => {
		setData(apiData);
		if (footerData) {
			const socialArray = [];
			const AuthorLogoArray = [];

			footerData?.common_images?.map((item) => {
				if (item.title === "Social Media Icon List") {
					socialArray.push(item);
				}
				if (item.title === "user") {
					AuthorLogoArray.push(item);
				}
			});
			setAuthorLogo(AuthorLogoArray);
			setSocialIcon(socialArray);
			setLoader(false);
		}
		// data && setLoader(false)
	}, [footerData]);

	return (
		<>
			<Head>
				<title>{striptags(title)}</title>

				<meta name="title" content={seo_title} key="og-title" />

				<meta name="description" content={search_description} key="og-desc" />
				<link rel="canonical" href={canonicalUrl} />
				<meta property="og:title" content={og_title || seo_title} />
				<meta property="og:description" content={og_description || search_description} />
				<meta property="og:image" content={og_image} />
				<meta property="og:url" content={canonicalUrl} />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Quixom" />
				{structuredData && (
					<script
						type="application/ld+json"
						dangerouslySetInnerHTML={formatJson(structuredData)}
					/>
				)}
			</Head>

			<Layout
				webLogo={
					footerData &&
					footerData?.site_configuration &&
					footerData?.site_configuration[0]?.logo?.url
				}
			>
				{loader && <Loader />}
				<main className="main-wrapper blog-detail-middle wrapper-top-bg">
					<article className="wrapper-inner">
						<section className="blog-detail-section">
							<div className="blog-detail-inner">
								<div className="container">
									<ul className="blog-detail-list">
										<li>{formattedDate}</li>
										<li>{data?.reading_times}</li>
									</ul>
									<div className="blog-detail-heading">
										<span
											dangerouslySetInnerHTML={{ __html: data?.heading }}
										></span>
										<ul className="social-icon-list">
											{socialIcon &&
												socialIcon[0]?.images?.map((val, innerIndex, array) => {
													const urlHtml = val?.value?.url;
													const hrefMatch = /href="([^"]+)"/.exec(urlHtml);
													const href = hrefMatch ? hrefMatch[1] : "";
													const redirectToCurrentBlog = (e, socialNetwork) => {
														e.preventDefault();
														const currentPageURL = window.location.href;
														let shareURL = "";

														switch (socialNetwork) {
															case "facebook":
																shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
																	currentPageURL
																)}`;
																break;
															case "twitter":
																shareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
																	currentPageURL
																)}`;
																break;
															case "linkedin":
																shareURL = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
																	currentPageURL
																)}`;
																break;
															// Add more cases for other social networks if needed

															default:
																break;
														}

														window.location = shareURL;
													};

													const copyCurrentPageURL = (e) => {
														e.preventDefault();
														const currentPageURL = window.location.href;
														const textArea = document.createElement("textarea");
														textArea.value = currentPageURL;
														document.body.appendChild(textArea);
														textArea.select();
														document.execCommand("copy");
														document.body.removeChild(textArea);
													};
													return (
														<li key={innerIndex}>
															<Link
																href={href}
																onClick={(e) => {
																	if (innerIndex === array.length - 1) {
																		copyCurrentPageURL(e);
																	} else {
																		redirectToCurrentBlog(e, val?.value?.title);
																	}
																}}
															>
																<Image
																	height={100}
																	width={100}
																	src={val?.value?.url}
																	alt={val?.value?.alt_text ?? 'Thank you'}
																	loading="eager"
																/>
															</Link>
														</li>
													);
												})}
										</ul>
									</div>
									<div
										className="blog-right-content"
										id="0"
										dangerouslySetInnerHTML={{
											__html: data?.description,
										}}
									></div>
								</div>
							</div>
							<div className="container">
								<div className="blog-detail-banner">
									<Image
										height={4000}
										width={4000}
										src={data?.image?.url}
										alt={data?.image?.alt_text ?? 'blog-detail-banner'}
										loading="eager"
									/>
								</div>
							</div>
						</section>
						<section className="blog-list-section">
							<div className="blog-list-inner">
								<div className="container">
									<div className="row">
										<div className="col-lg-3 col-md-4">
											<div className="blog-left-tab">
												<ul>
													{data?.body?.map((val, index) => {
														if (val?.type == "blog_section" || val?.type == "faq") {
															return (
																<li key={index}>
																	<AnchorLink
																		key={index}
																		offset={() => 120}
																		href={`#${index}`}
																		className={`${activeTab == index ? "active" : ""
																			}`}
																		dangerouslySetInnerHTML={{
																			__html:
																				val?.value?.sidebar_title || "FAQs",
																		}}
																		onClick={() => {
																			setActiveTab(index);
																		}}
																	></AnchorLink>
																</li>
															);
														}
													})}
												</ul>
											</div>
										</div>
										<div className="col-lg-9 col-md-8">
											<div className="blog-right-tab">
												{/* <div
													className="blog-right-content"
													id="0"
													dangerouslySetInnerHTML={{
														__html: data?.description,
													}}
												></div> */}
												{data?.body?.map((val, index) => {
													if (val?.type == "blog_section") {
														return (
															<div
																className="blog-right-content"
																id={index}
																key={index}
															>
																<p
																	dangerouslySetInnerHTML={{
																		__html: val?.value?.title,
																	}}
																></p>
																<div
																	className="blog-text-box"
																	dangerouslySetInnerHTML={{
																		__html: val?.value?.description,
																	}}
																></div>
																{val?.value?.image && (
																	<div className="blog-image-box">
																		<Image
																			height={2000}
																			width={2000}
																			src={val?.value?.image?.url}
																			alt={val?.value?.image?.alt_text ?? 'blog-banner'}
																			loading="eager"
																		/>
																	</div>
																)}
															</div>
														);
													}
													if (val?.type == "cta") {
														return (
															<div className="bog-detail-page">
																<CommonCtaSection data={val} />
															</div>
														)
													}
													if (val?.type == "faq") {
														return (
															<div
																className=""
																id={index}
																key={index}
																style={{
																	fontSize: "32px",
																	lineHeight: "40px",
																	fontWeight: 500,
																	paddingTop: "32px",
																	marginBottom: "16px",
																	paddingBottom: 0,
																}}
															>
																<FaqSection
																	key={index}
																	serviceDetail={val}
																	showAllFaqs={showAllFaqs}
																	activeindex={activeItem}
																	setShowAllFaqs={() => {
																		setShowAllFaqs(true);
																	}}
																/>
															</div>
														)
													}
													if (val?.type == "author_snippet") {
														return (
															<div
																className="blog-right-content"
																id="4"
																key={index}
															>
																<div className="blog-profile-card">
																	<div className="profile-left-img">
																		<Image
																			height={1000}
																			width={1000}
																			src={
																				val?.value?.image
																					? val?.value?.image
																					: authorLogo &&
																					authorLogo[0]?.images[0]?.value?.url
																			}
																			alt={authorLogo[0]?.images[0]?.value?.alt_text ?? 'blog-profile'}
																			loading="eager"
																		/>
																	</div>
																	<div className="profile-right-content">
																		<div className="profile-user-name">
																			<span>{striptags(val?.value?.heading)}</span>
																			<span>{val?.value?.name}</span>
																		</div>
																		<p
																			dangerouslySetInnerHTML={{
																				__html: val?.value?.description,
																			}}
																		></p>
																	</div>
																</div>
															</div>
														);
													}
												})}
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</article>

				</main>
			</Layout>
		</>
	);
};

export async function getServerSideProps(context) {
	// Fetch data from your API

	const { query } = context; // Access query parameters directly from the context
	const yourValue = query.slug;

	// const URLs = localStorage.getItem("apiLink");

	const response = await fetch(
		process.env.NEXT_PUBLIC_API_ENDPOINT + `/cms/pages/${yourValue}`,
		{ next: { revalidate: 3600 } }
	);
	const apiData = await response.json();

	if (apiData?.redirect_url) {
		return {
			redirect: {
				destination: apiData.redirect_url,
				permanent: false,
			},
		};
	}

	return {
		props: {
			apiData,
		},
	};
}
export default BlogDetail;
